import { BaseComponent } from "react-vextensions";
import { PanelHeader } from "UI/Write/MapUI/Panel";
export class HistoryPanel extends BaseComponent {
    render() {
        return (React.createElement(PanelHeader, { text: "History" }));
    }
}
